import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionContact, ElectionSirets, ElectionVenue } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-contact',
  templateUrl: 'cerfa-contact.component.html',
  styleUrls: ['./cerfa-contact.component.less', '../../../shared/common.less'],
})

export class CerfaContactComponent implements OnInit {
  @Input() contact: ElectionContact;
  @Output() contactChange = new EventEmitter<ElectionContact>();
  needPap: boolean = undefined;

  constructor() {}
  
  onContactChange() {
    this.contactChange.emit(this.contact);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  trackByIndex(index: number): number {
    return index;
  }

  
  ngOnInit(): void {
  }
}
